import {
  WEBTREKK_LOAD_SUCCESS_EVENT,
} from './webtrekkConstants';

let queuedRequestContexts = [];

function queueRequest(eventData) {
  queuedRequestContexts.push(
    {
      eventData,
    }
  );
}

function triggerQueuedEvents() {
  if (queuedRequestContexts) {
    queuedRequestContexts.forEach(
      ({eventData}) => {
        trackEvent(eventData);
      }
    );
  }
}

function trackEvent(eventData) {
  webtrekkApiClient.webtrekkInstance.sendinfo(eventData);
}

const webtrekkApiClient = {
  sendEventRequest(eventData) {
    return new Promise((resolve, reject) => {
      if (webtrekkApiClient.webtrekkInstance) {
        trackEvent(eventData);
      } else {
        queueRequest(eventData);
      }

      resolve({data: {}});
    });
  },
};

function setWebtrekkInstance() {
  webtrekkApiClient.webtrekkInstance = new window.webtrekkV3(window.webtrekkConfig);
}

if (window.addEventListener) {
  if (window.webtrekkV3) {
    setWebtrekkInstance();
    triggerQueuedEvents();
  } else {
    window.addEventListener(
      WEBTREKK_LOAD_SUCCESS_EVENT,
      function() {
        if (window.webtrekkV3) {
          setWebtrekkInstance();
          triggerQueuedEvents();
        } else {
          queuedRequestContexts = null;
        }
      }
    );
  }
}

export default webtrekkApiClient;
